export default "__VITE_ASSET__BgufivK2__"